import axios from 'axios';
import { OrderDistribution } from 'views/order-feed/features/order-distribution/types/order-distribution.type';
import { UpdateOrderDistributionInput } from 'views/order-feed/features/order-distribution/types/update-order-distribution-input.type';

// POST
// /ewosapi/v1/order-distribution/customer/{customerNumber}/{orderDistributionId}
export const putOrderDistribution = async (
  customerNumber: string,
  orderDistributionId: string,
  request: UpdateOrderDistributionInput
): Promise<OrderDistribution> => {
  return await axios.put(`ewosapi/v1/order-distribution/customer/${customerNumber}/${orderDistributionId}`, request);
};
